import React from 'react';
import Typography from '@material-ui/core/Typography';
import PDFLink from '../../components/generate-pdf/PDFLink';
import { Fab } from '@material-ui/core';
import InfoMessageBar from '../common/info-message/info-message';
import Card from '@material-ui/core/Card';
import Title from '../common/custom-components/customTitleHeader';
import CardContent from '@material-ui/core/CardContent';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';
import Link from '@material-ui/core/Link';
import './upload-contract.css';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
const UploadContractForm = props => {
  return (
    <React.Fragment>
      <div className="container page" style={{ backgroundColor: '#F7F8F9' }}>
        <div className="row">
          <div className="col-md-6 offset-md-3 col-xs-12">
            <Card boxShadow={3} style={{ marginTop: 20 }}>
              <div className="headerAlign">
                <Title text="Surety Bond Contract" />
              </div>
              {props.errors && (
                <InfoMessageBar
                  icColor="errorIc"
                  variant="error"
                  message={props.errors}
                />
              )}
              {props.message && (
                <InfoMessageBar
                  variant="success"
                  icColor="successIc"
                  message={props.message}
                />
              )}
              {props.upload && (
                <InfoMessageBar
                  variant="success"
                  message="Successfully Uploaded.."
                />
              )}
              <Typography
                variant="subtitle1"
                className="text-xs-center"
                color="primary"
                gutterBottom
                style={{ fontFamily: 'roman', fontSize: 22 }}
              >
                DOWNLOAD THE CONTRACT
              </Typography>
              <CardContent>
                <Typography className="body1" gutterBottom variant="body1">
                  Download and print the contract. Follow the instructions on
                  the form.
                </Typography>
                <Typography
                  variant="h6"
                  className="text-xs-center"
                  color="primary"
                  gutterBottom
                  style={{ fontFamily: 'roman', fontSize: 22 }}
                >
                  <PDFLink
                    className="btn btn-secondary btn-lg pull-xs-left btn-margin"
                    data={props.data}
                    fileName={props.data.companyName + '.pdf'}
                    title={props.data.companyName + ''}
                  />
                </Typography>
              </CardContent>
            </Card>
            <Card boxShadow={3} style={{ marginTop: 20 }}>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  className="text-xs-center"
                  color="primary"
                  gutterBottom
                  style={{ fontFamily: 'roman', fontSize: 22 }}
                >
                  UPLOAD THE SIGNED CONTRACT
                </Typography>
                <Typography className="body1" gutterBottom variant="body1">
                  Upon receipt of Surety Bond and Power of Attorney from
                  Insurance/Surety Company, upload the contract for review by
                  the FPL Deposit Administrator.
                </Typography>
                <div className="link-align">
                  <label htmlFor="upload-button">
                    <input
                      id="upload-photo"
                      name="upload-photo"
                      type="file"
                      ref={props.hiddenFileInput}
                      onChange={props.handleFile}
                      style={{ display: 'none' }}
                    />

                    <Fab
                      color="primary"
                      size="small"
                      component="button"
                      aria-label="add"
                      variant="extended"
                      onClick={props.handleUpload}
                    >
                      UPLOAD PDF CONTRACT
                    </Fab>
                  </label>
                </div>
                <br />
                {props.data.pdfLink !== null && (
                  <div className="text-xs-center">
                    <a
                      href={props.data.pdfLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-xs-center"
                    >
                      View the Uploaded Contract
                    </a>
                    <Link
                      component="button"
                      align="center"
                      className="text-xs-center"
                      variant="h6"
                      color="primary"
                      onClick={props.handleContractDelete}
                    >
                      <Tooltip
                        title="Delete the uploaded Contract"
                        placement="right"
                      >
                        <DeleteIcon />
                      </Tooltip>
                    </Link>
                  </div>
                )}{' '}
              </CardContent>
            </Card>
            <Card boxShadow={3} style={{ marginTop: 20 }}>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  className="text-xs-center"
                  color="primary"
                  gutterBottom
                  style={{ fontFamily: 'roman', fontSize: 22 }}
                >
                  WHAT TO EXPECT
                </Typography>
                <Typography className="body1" gutterBottom variant="body1">
                  Once the uploaded contract has been approved by our Deposit
                  Administration team, you will be notified to mail originals.
                  Please retain a copy and send original to:
                </Typography>
                <div className="address-box">
                  <strong className="text-xs-center">
                    {' '}
                    FPL, Attention:
                    <br /> RRD\LFO Deposit Administration,
                    <br /> 4200 W.Flagler Street,
                    <br /> Coral Gables, FL 33134.
                  </strong>
                </div>

                <Typography className="body1" gutterBottom variant="body1">
                  Upon receipt of the completed Surety Bond, all cash deposits
                  will be applied to the account.
                </Typography>
              </CardContent>
              <div className="link-align">
                <Button
                  className="btn-lg "
                  variant="contained"
                  color="primary"
                  type="submit"
                  onClick={props.handleBackFromPDFHome}
                  id="submit"
                  align="center"
                >
                  Go to HomePage
                </Button>
              </div>
              <div className="link-align-back">
                <Link
                  component="button"
                  align="center"
                  className="text-xs-center"
                  variant="h6"
                  color="primary"
                  onClick={props.handleBack}
                  style={{ padding: '15px 150px' }}
                >
                  BACK
                </Link>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

UploadContractForm.propTypes = {
  errors: PropTypes.string,
  message: PropTypes.string,
  handleFile: PropTypes.func,
  handleUpload: PropTypes.func,
  handleBack: PropTypes.func,
  upload: PropTypes.func,
  data: PropTypes.shape({
    companyName: PropTypes.string,
    pdfLink: PropTypes.string,
  }),
  handleBackFromPDFHome: PropTypes.func,
  corrections: PropTypes.bool,
  hiddenFileInput: PropTypes.func,
  handleContractDelete: PropTypes.func,
};
export default UploadContractForm;
